"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromJwt = void 0;
const jwt_1 = require("./jwt");
/**
 * Create `Tokens` from JWT tokens.
 * Expiry will be extracted from the given tokens if no override is set.
 *
 * @throws If no expiry override is set and not `exp` claim is found in the tokens.
 */
function fromJwt({ accessToken, accessTokenExp, refreshToken, refreshTokenExp, }) {
    accessTokenExp !== null && accessTokenExp !== void 0 ? accessTokenExp : (accessTokenExp = (0, jwt_1.peekPayload)(accessToken).exp);
    if (accessTokenExp == null)
        throw new Error("No expiry found for access token");
    refreshTokenExp !== null && refreshTokenExp !== void 0 ? refreshTokenExp : (refreshTokenExp = (0, jwt_1.peekPayload)(refreshToken).exp);
    if (refreshTokenExp == null)
        throw new Error("No expiry found for refresh token");
    return { accessToken, accessTokenExp, refreshToken, refreshTokenExp };
}
exports.fromJwt = fromJwt;
